import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  signupCard: {
    // width: '30%',
  },
}));

export default useStyles;
